<div *ngIf="mediumGroup" class="d-flex justify-content-center align-items-center tableBg">
  <sb-comp-image-name-wrapper
    [hoverPreview]="true"
    [showFullOnClick]="true"
    [customHeight]="'100%'"
    *ngIf="mediumGroup"
    thumbnailSize="S"
    [customWidth]="'200px'"
    [medium]="mediumGroup?.preview">
    <h5 firstLine>{{ mediumGroup?.name }}</h5>
    <p secondLine>{{ mediumGroup?.mediaCount }} {{ 'lang.globals.motives' | translate }}</p>
    <div thirdLine>
      <sb-comp-display-created [data]="mediumGroup" [showHeadline]="true"></sb-comp-display-created>
    </div>
  </sb-comp-image-name-wrapper>
</div>
